const formatUrl = (url: string, width: number, height?: number) => {
  const separator = url.includes('?') ? '&' : '?';

  const u = new URL(url);
  u.searchParams.delete('hei');
  u.searchParams.delete('wid');
  const cleanUrl = u.toString();

  if (height) {
    const aspect = Math.floor((1000 * height) / width) / 1000;
    return `${cleanUrl}${separator}fmt=auto&wid=${width}&sm=aspect&aspect=1:${aspect}`;
  }
  return `${cleanUrl}${separator}fmt=auto&wid=${width}&sm=aspect&aspect=1:1`;
};

export const getThumbnailUrls = (
  baseUrl: string,
  width: number,
  height?: number
) => {
  const src = formatUrl(baseUrl, width, height);
  const srcset = [
    `${src} 1x`,
    `${formatUrl(baseUrl, width * 2, height ? height * 2 : undefined)} 2x`,
    `${formatUrl(baseUrl, width * 3, height ? height * 3 : undefined)} 3x`,
  ].join(', ');

  return { src, srcset };
};
